import "./LinkContainer.scss";

import * as React from "react";
import { Link } from "react-router";
import _ from "lodash";

type Props = {
    to: any;
    children: React.ReactNode;
    customClass?: string | null;
    onClick?: (event?: any) => void;
};

function LinkContainerWrapper(props: Props & { [k: string]: any }) {
    const newProps = _.omit(props, ["to", "customClass"]) as any;
    const customClass = props.customClass;
    newProps.className = customClass + (newProps.className || "");
    return (
        <Link to={props.to || ""} {...newProps} onClick={props.onClick}>
            {props.children}
        </Link>
    );
}

LinkContainerWrapper.defaultProps = {
    customClass: "ex-linkcontainer "
};

export default LinkContainerWrapper;
